import { CAR_PRIZE_JAN_26_URL } from '../../containers/app/homepage/Components/CarPrizeJan2026/CarPrizeJan2026.helpers';
import { SELL_MY_CAR_PATH } from '../wordpress';

import { PAGES, snowplowEvent } from './analytics';
import { GENERIC_ANALYTICS_EVENTS } from './analyticsGenericEvents';
import { getAdditionalParams } from './analyticsValuations';

export const HOMEPAGE_SECTIONS = {
  CAR_PRIZE_JAN_2026: 'car_prize_jan_2026',
  CLAIM: 'claim',
  FAQ: 'faq',
  FULL_BLEED_IMAGE: 'full_bleed_image',
  GUIDES: 'guides',
  HERO: 'hero',
  HOW_IT_WORKS: 'how_it_works',
  NEWS_AND_TOOLS: 'whats_new_tile',
  RECOMMENDED_BY: 'recommended_by',
  RELATED_GUIDES: 'related_guides',
  REVIEWS: 'reviews',
  SELLER_STORIES: 'seller_stories',
  SOCIAL_PROOF: 'social_proof',
} as const;

export const HOMEPAGE_SP_SECTIONS = {
  HOMEPAGE: 'homepage',
  SMV: 'smv_val',
} as const;

export const LANDINGPAGE_SECTIONS = {
  HERO: 'Landing Page Hero',
} as const;

export type SectionName =
  | (typeof HOMEPAGE_SECTIONS)[keyof typeof HOMEPAGE_SECTIONS]
  | (typeof LANDINGPAGE_SECTIONS)[keyof typeof LANDINGPAGE_SECTIONS];

export const EVENT_ACTIONS = {
  CTA_CLICKED: 'CTA Clicked',
  GUIDE_CLICKED: 'Guide clicked',
  GUIDES_CAROUSEL_SCROLLED: 'Guides carousel scrolled',
  GUIDES_CTA_CLICKED: 'Explore guides CTA clicked',
  HERO_MILEAGE_CTA_CLICKED: 'Continue CTA clicked',
  HERO_VRM_CTA_CLICKED: 'Value my car CTA clicked',
  HERO_VRM_INPUT_FOCUSSED: 'VRM input focussed',
  NEWS_AND_TOOLS_TILE_CLICKED: 'Tile clicked',
  SECTION_LOADED: 'Section Loaded',
} as const;

export const HOMEPAGE_GA_TAGS = {
  GUIDE_CLICKED: (data: {
    readonly link: string;
    readonly title: string;
  }) => {
    GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
      category: PAGES.HOME,
      label: data.title,
      name: 'guides_tile',
      url: data.link,
    });
  },
  GUIDES_EXPLORE_CLICKED: (url: string) => {
    GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
      category: PAGES.HOME,
      name: 'guides_explore',
      url,
    });
  },

  HERO_INVALID_VRM_WARNING_SHOWN: (vrm: string) => {
    snowplowEvent({
      data: { vrm },
      schema: 'smv_upperfunnel_vrm_submit_error',
    });
  },

  HERO_MILEAGE_SHOWN: (vrm: string, mileage?: number) => {
    snowplowEvent({
      ...getAdditionalParams({ pre_filled_mileage: mileage || null, vrm }),
      schema: 'smv_upperfunnel_mileage_arrival',
      version: '2-0-0',
    });
  },

  HERO_VRM_CTA_CLICKED: () => {},

  HERO_VRM_INPUT_FOCUSSED: () => {
    GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({ category: PAGES.HOME, name: 'vrm_input' });
  },

  NEWS_AND_TOOLS_TILE_CLICKED: (label: string, url: string) => {
    GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
      category: PAGES.HOME,
      label,
      name: HOMEPAGE_SECTIONS.NEWS_AND_TOOLS,
      url,
    });
  },

  SECTION_CTA_CLICKED: (category: SectionName, label?: string, redirectTo?: string) => {
    GENERIC_ANALYTICS_EVENTS.CTA_CLICK(
      {
        button_label: label ?? 'Sell Your Car',
        category: PAGES.HOME,
        label: category,
        name: 'sell_my_car',
        url: redirectTo ?? `https://motorway.co.uk${SELL_MY_CAR_PATH}`,
      },
    );
  },

  SECTION_LOADED: (category: SectionName, label?: string) => {
    GENERIC_ANALYTICS_EVENTS.SECTION_LOAD_EVENT({
      category: PAGES.HOME,
      label,
      name: category,
    });
  },

} as const;

export const HOMEPAGE_SNOW_PLOW_EVENTS = Object.freeze({
  CAR_PRIZE_CLICKED: (buttonLabel: string) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: buttonLabel,
    category: HOMEPAGE_SP_SECTIONS.HOMEPAGE,
    name: 'car_prize_jan_2026',
    url: CAR_PRIZE_JAN_26_URL,
  }),

  HERO_RETURN_USER_ADD_VEHICLE_CLICKED: () => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: HOMEPAGE_SP_SECTIONS.HOMEPAGE,
    name: 'returning_user_sell_another_vehicle',
  }),

  HERO_RETURN_USER_CONTINUE_CLICKED: (
    { buttonLabel, url }: { buttonLabel: string; url: string },
  ) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: buttonLabel,
    category: HOMEPAGE_SP_SECTIONS.SMV,
    label: 'returning_user_component',
    name: 'offer_selected',
    url,
  }),

  HERO_RETURN_USER_LOADED: (label?: string) => GENERIC_ANALYTICS_EVENTS.SECTION_LOAD_EVENT({
    category: HOMEPAGE_SP_SECTIONS.HOMEPAGE,
    label,
    name: 'returning_user_component',
  }),
});
